import React from 'react';
import { Card } from "react-bootstrap";
import faceAndrasNemeslaki from "../../assets/img/faceAndrasNemeslaki.jpg";
import ShowMoreText from "react-show-more-text";
import projNemeslakiA_dynamics from "../../assets/img/projNemeslakiA_dynamics.png";

const Andras_Nemeslaki_dynamics = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={projNemeslakiA_dynamics} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={faceAndrasNemeslaki}
            />{" "}
            <p className="text7">András Nemeslaki</p>
            <br />
            <p className="text8">
              Professor, Vice Rector{" "}
            </p>
            <p className="text8">Department of Management and Business Economics, BME </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            The research focuses on the development and analysis of system dynamics simulation models. These models rely on simple 
            differential equations and phase diagrams to describe and visualize dynamic behaviors in various applied contexts, such 
            as population growth, resource cycles, epidemiology, and economic systems.

            <br />

            The work emphasizes the following activities:
            <ul>
                <li>
                   Formulating mathematical models of dynamical systems using ordinary differential equations (ODEs). 
                </li>
                <li>
                   Applying analytical and numerical methods to investigate system stability, equilibria, and bifurcations.
                </li>
                <li>
                   Visualizing system behavior through phase diagrams and simulations.
                </li>
                <li>
                   Extending the insights to interdisciplinary applications.
                </li>
            </ul>
            The project is designed for candidates with a solid background in differential equations, dynamical systems, and mathematical 
            modeling. Familiarity with simulation tools or programming languages (e.g., Python, MATLAB, Julia) can be an asset, but it is 
            not a strict requirement.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Andras_Nemeslaki_dynamics;